import { toast as toastify } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const toastFunction = (status, message) =>{
    if(status==='error'){
        toastify.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored", // This is the key for a beautiful, colored theme
        });
    }else if(status==="success"){
        toastify.success(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored", // This is the key for a beautiful, colored theme
        });
    }else{
        toastify.warning(message,{
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }
}

const storeProfile = (data) =>{
    localStorage.setItem('profile', JSON.stringify(data));
}
const getCustomizedFields = (tableName) =>{
    const profile = localStorage.getItem('profile');
    if(profile){
        const profileData = JSON.parse(profile);
        if(profileData.customization && typeof profileData.customization === 'object'){
            if(profileData.customization[tableName]){
                return profileData.customization[tableName];
            }
        }
    }
    return [];
}

const getCompanyData = () =>{
    const profile = localStorage.getItem('profile');
    if(profile){
        const profileData = JSON.parse(profile);
        let company = {};
        if(profileData.companyName) company["name"] = profileData.companyName;
        if(profileData.email) company["email"] = profileData.email;
        if(profileData.phoneNumber) company["phone"] = profileData.phoneNumber;
        if(profileData.logoUrl) company["logoUrl"] = profileData.logoUrl;
        if(profileData.gstNumber) company["gstin"] = profileData.gstNumber;
        if(profileData.industry) company["industry"] = profileData.industry;
        if(profileData.address) {
            const addr = profileData.address;
            company["address"] = typeof addr === 'object'
                ? (addr.addressLine1 || addr.line1 || addr.street || '')
                : addr;
        }
        if(profileData.city) company["city"] = profileData.city;
        if(profileData.state) company["state"] = profileData.state;
        if(profileData.stateCode) company["stateCode"] = profileData.stateCode;
        if(profileData.pincode) { company["zip"] = profileData.pincode; company["pincode"] = profileData.pincode; }
        if(profileData.pan) company["pan"] = profileData.pan;
        if(profileData.website) company["website"] = profileData.website;
        if(profileData.bankName) company["bankName"] = profileData.bankName;
        if(profileData.accountNumber) company["accountNumber"] = profileData.accountNumber;
        if(profileData.ifscCode) company["ifscCode"] = profileData.ifscCode;
        if(profileData.tagline) company["tagline"] = profileData.tagline;
        if(profileData.dlNo1) company["dlNo1"] = profileData.dlNo1;
        if(profileData.fssai) company["fssai"] = profileData.fssai;
        if(profileData.license) company["license"] = profileData.license;
        if(profileData.regNo) company["regNo"] = profileData.regNo;
        if(profileData.settings && typeof profileData.settings === 'object') company["settings"] = profileData.settings;
        return company;
    }
    return {};
}

const setCustomizedFields = (tableName, data) =>{
    const profile = localStorage.getItem('profile');
    if(profile){
        const profileData = JSON.parse(profile);
        if(!profileData.customization || typeof profileData.customization !== 'object'){
            profileData.customization = {};
        }
        profileData.customization[tableName] = data;
        localStorage.setItem('profile', JSON.stringify(profileData));
    }
}

const getCardDetails = (element,fields, tabName) =>{
    let cardDetails =  []
    fields.map((field) => {
            if(field.tab==tabName){
              if(field.key=="id")
                  return;
              const value = getNestedValue(element,field.key)
              if(value && value!=""){
                cardDetails.push(<div>
                        <div className="centered-cell">
                          <div className="info-item">
                            <label><strong>{field.label}</strong></label>
                            <span>{value} </span>
                          </div>
                        </div>
                      </div>);
                }
              }
            }
          );
      return cardDetails;
  }

const showSpinner = () =>{
    return (
      <div className="spinner-container">
        <div className="spinner"></div> {/* The spinner element */}
      </div>
    );
  }

const getNestedValue = (obj, key) => {
    return key.split('.').reduce((acc, part) => {
      return acc && acc[part] !== undefined ? acc[part] : undefined;
    }, obj);
  };

export const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

// Returns an error string if the value is present but invalid; null if valid or empty.
export const validateGSTIN = (value) => {
  if (!value) return null;
  return GSTIN_REGEX.test(value.toUpperCase())
    ? null
    : 'Invalid GSTIN format (expected 15-char format, e.g. 29ABCDE1234F1Z5).';
};

// Base64-encodes a UTF-8 string (plain btoa() chokes on non-ASCII chars like ₹).
// Used to send raw HTML template strings to the backend without literal
// markup (<div>, <style>, {{ }}) appearing in the request body — AWS WAF's
// managed rules flag that pattern as XSS even though it's just a template.
const encodeUtf8Base64 = (str) => btoa(unescape(encodeURIComponent(str)));

export {
    toastFunction,
    storeProfile,
    getCustomizedFields,
    setCustomizedFields,
    getCardDetails,
    getCompanyData,
    showSpinner,
    getNestedValue,
    encodeUtf8Base64
}